import React from 'react';
import { connect } from 'react-redux';

import { closeLoading } from '@/redux/actions';
import styles from './style.module.styl';
import { connectQuery, getUrlParam, loadWxLoginSDK } from '@/utils/util';
import api from '@/api';
const query = getUrlParam();

class LoginPC extends React.Component {
    constructor(props) {
        super(props);
        this.props.closeLoading();
        this.state = {
            styleBase64:
                'data:text/css;base64,LmltcG93ZXJCb3gge3dpZHRoOiBhdXRvO30NCi5pbXBvd2VyQm94IC5xcmNvZGUge3dpZHRoOiAxODRweDttYXJnaW46IDAgYXV0b30NCi5pbXBvd2VyQm94IC50aXRsZSB7ZGlzcGxheTogbm9uZTt9DQouaW1wb3dlckJveCAuaW5mbyB7ZGlzcGxheTogbm9uZTt9DQouc3RhdHVzX2ljb24ge2Rpc3BsYXk6IG5vbmV9DQouaW1wb3dlckJveCAuc3RhdHVzIHt0ZXh0LWFsaWduOiBjZW50ZXI7fQ==',
            expired: false,
        };
    }

    componentDidMount() {
        loadWxLoginSDK(() => {
            this.initWxLogin();
        });
    }

    liveReportFun = ({ process, eventType, reason, requestUrl, extend = {} }) => {
        try {
            if (window['live_report']) {
                window['live_report'].setLiveReportData({
                    url: window.location.href,
                    process,
                    eventType,
                    reason,
                    requestUrl,
                    extend,
                });
            }
        } catch (e) {
            console.log(e, 'errorReport');
        }
    };

    /**
     * 微信登录
     */
    initWxLogin = () => {
        api.getWechatConfig({
            wechatType: 300,
        }).then(({ code, data }) => {
            if (code === 0 && data) {
                try {
                    const { appId, type } = data;
                    const params = {
                        ...query,
                        wechatType: type,
                    };
                    const redirectUrl = encodeURIComponent(
                        `${window.location.origin}${params.redirectUrl || '/'}?${connectQuery(params)}`,
                    );
                    // eslint-disable-next-line
                    const obj = new WxLogin({
                        self_redirect: false,
                        id: 'login_container',
                        appid: appId,
                        scope: 'snsapi_login',
                        redirect_uri: redirectUrl,
                        state: Math.ceil(Math.random() * 1000),
                        style: '',
                        href: this.state.styleBase64,
                    });

                    setTimeout(() => {
                        this.setState({
                            expired: true,
                        });
                    }, 60000);
                } catch (e) {
                    this.liveReportFun({
                        process: 'getToken',
                        eventType: 'wechatCode',
                        reason: 'error',
                        noUserInfo: true,
                        immediate: true,
                        requestUrl: 'weixinPcLogin',
                        extend: {
                            ...query,
                            reasonDetail: e,
                        },
                    });
                    console.log(e, '授权出错');
                }
            }
        });
    };

    refreshQrCode = () => {
        this.setState({
            expired: false,
        });
        this.initWxLogin();
    };

    render() {
        const { expired } = this.state;
        return (
            <div className={styles.loginPC}>
                <div className={styles.loginPCContainer}>
                    <img
                        className={styles.logo}
                        src="https://qnunion.feierlaiedu.com/kcschool/5cDEjVdW8h2r80jsHWfVpW9dUgRgLLRH"
                        alt="讲真logo"
                    />

                    <div className={styles.loginPCQrCOdeBox}>
                        <img
                            className={styles.qrCodeImg}
                            src="https://qnunion.feierlaiedu.com/kcschool/lNNcVfHUnnMDOYZ3IN5IyulygNHxpesb"
                            alt="默认"
                        />

                        <div className={styles.qrCode}>
                            <div className={styles.qrCodeTitle}>请使用微信扫描二维码登录</div>

                            <div className={styles.content}>
                                <div id="login_container" />
                                {expired && (
                                    <div className={styles.expired} onClick={this.refreshQrCode}>
                                        <div>二维码失效</div>
                                        <div>
                                            请点击刷新<span>刷新</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default connect(null, { closeLoading })(LoginPC);
